import { render } from "./PlayReservations.vue?vue&type=template&id=1702b6d5&scoped=true"
import script from "./PlayReservations.vue?vue&type=script&lang=js"
export * from "./PlayReservations.vue?vue&type=script&lang=js"

import "./PlayReservations.vue?vue&type=style&index=0&id=1702b6d5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702b6d5"]])

export default __exports__